// extracted by mini-css-extract-plugin
module.exports = {"container":"BookmarkFolder_container__3jHSW","foldername":"BookmarkFolder_foldername__2HKki","selected":"BookmarkFolder_selected__bqE6J"};